module.exports = __webpack_public_path__ + "img/payBannerGreen.6af89b78.jpg";